import { useCallback, useState } from 'react';
import { ConfirmationDialogProps } from '../components';

export const useConfirmationDialog = () => {
    const [confirmation, setConfirmation] = useState<ConfirmationDialogProps>({
        isOpen: false,
        title: '',
        message: '',
        okButton: '',
        onClose: () => {},
        onSubmit: () => {}
    });
    const requestConfirmation = useCallback(
        async ({
            title,
            message,
            okButton
        }: Pick<ConfirmationDialogProps, 'title' | 'message' | 'okButton'>) => {
            return new Promise<boolean>((resolve) => {
                setConfirmation({
                    ...confirmation,
                    isOpen: true,
                    title,
                    message,
                    okButton,
                    onClose: () => {
                        resolve(false);
                        setConfirmation({ ...confirmation, isOpen: false });
                    },
                    onSubmit: () => {
                        resolve(true);
                        setConfirmation({ ...confirmation, isOpen: false });
                    }
                });
            });
        },
        [confirmation]
    );

    return { confirmation, requestConfirmation };
};
